import Joi from '@hapi/joi'

export const AttendanceDonwnloadSchema = {

    fromDate: Joi.string().invalid("").label("From Date"),
    toDate: Joi.string().invalid("").label("To Date")

}